module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "gv-gas gv-inverted-color-scheme",
    attrs: {
      "id": "gv-gas"
    }
  }, [_vm._c('gv-title', {
    directives: [{
      name: "draggable",
      rawName: "v-draggable"
    }],
    attrs: {
      "title": _vm.title,
      "divId": 'gv-gas',
      "noClose": true,
      "collapsible": 'gv-gas-body'
    }
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "gv-gas-body",
    attrs: {
      "id": "gv-gas-body"
    }
  }, [_vm._c('el-select', {
    staticClass: "gv-gas-combo",
    attrs: {
      "placeholder": "Seleziona Area",
      "size": "mini"
    },
    on: {
      "change": _vm.onChangeArea
    },
    model: {
      value: (_vm.area),
      callback: function($$v) {
        _vm.area = $$v
      },
      expression: "area"
    }
  }, _vm._l((_vm.aree), function(item) {
    return _vm._c('el-option', {
      key: item.codice,
      attrs: {
        "value": item.codice,
        "label": item.descrizione
      }
    })
  })), _vm._v(" "), _vm._c('el-select', {
    staticClass: "gv-gas-combo",
    attrs: {
      "placeholder": "Seleziona Modulo",
      "size": "mini"
    },
    model: {
      value: (_vm.modulo),
      callback: function($$v) {
        _vm.modulo = $$v
      },
      expression: "modulo"
    }
  }, _vm._l((_vm.moduli), function(item) {
    return _vm._c('el-option', {
      key: item.codice,
      attrs: {
        "value": item.codice,
        "label": item.descrizione
      }
    })
  })), _vm._v(" "), _vm._c('div', {
    staticClass: "gv-gas-checkbox"
  }, [_vm._c('el-checkbox', {
    model: {
      value: (_vm.soloPostiDisponibili),
      callback: function($$v) {
        _vm.soloPostiDisponibili = $$v
      },
      expression: "soloPostiDisponibili"
    }
  }, [_vm._v("Solo strutture con posti disponibili")])], 1), _vm._v(" "), _vm._c('el-select', {
    staticClass: "gv-gas-combo",
    attrs: {
      "placeholder": "Seleziona Provincia",
      "size": "mini"
    },
    on: {
      "change": _vm.onChangeProvincia
    },
    model: {
      value: (_vm.provincia),
      callback: function($$v) {
        _vm.provincia = $$v
      },
      expression: "provincia"
    }
  }, _vm._l((_vm.province), function(item) {
    return _vm._c('el-option', {
      key: item.codice,
      attrs: {
        "value": item.codice,
        "label": item.descrizione
      }
    })
  })), _vm._v(" "), _vm._c('el-select', {
    staticClass: "gv-gas-combo",
    attrs: {
      "placeholder": "Seleziona ASL",
      "size": "mini"
    },
    on: {
      "change": _vm.onChangeASL
    },
    model: {
      value: (_vm.asl),
      callback: function($$v) {
        _vm.asl = $$v
      },
      expression: "asl"
    }
  }, _vm._l((_vm.listaAsl), function(item) {
    return _vm._c('el-option', {
      key: item.codice,
      attrs: {
        "value": item.codice,
        "label": item.descrizione
      }
    })
  })), _vm._v(" "), _vm._c('el-button', {
    attrs: {
      "id": "gv-gas-submit",
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Visualizza")]), _vm._v(" "), _vm._c('el-button', {
    attrs: {
      "id": "gv-gas-elenco",
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-document"
    },
    on: {
      "click": _vm.elenco
    }
  }, [_vm._v("Elenco Strutture")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-582779dd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gas.vue
// module id = 859
// module chunks = 39